<template>
    <div class="container pull-up">
        <div class="row">
            <div class="col-md-12">
                <div class="card m-b-30">
                    <div class="card-header">
                        <h5 class="m-b-0">
                            <i class="mdi mdi-checkbox-intermediate"></i> {{ $t('item.title.archive') }}
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <data-tables :data="items.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
                                         :pagination-props="{ pageSizes: [10, 15, 30, 40, 100], pageSize: 10 }" center-align>
                                <el-table-column :label="$t('warehouse.label.serial_number')" type="index" sortable fixed></el-table-column>
                                <el-table-column prop="name" :label="$t('label.name')" min-width="180" fixed></el-table-column>
                                <el-table-column :label="$t('item.label.unit_price')" min-width="100" sortable fixed>
                                    <template slot-scope="scope">
                                        <span class="currency">{{ scope.row.unit_price | currency('XAF') }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="unit_type" :label="$t('item.label.unit_type')" sortable></el-table-column>
                                <el-table-column prop="user.name" :label="$t('item.label.creator')" sortable></el-table-column>
                                <el-table-column prop="created_at" :formatter="$shortDate" :label="$t('label.created_at')"
                                                 sortable></el-table-column>
                                <el-table-column :label="$t('label.action')" min-width="100px">
                                    <template slot="header" slot-scope="scope">
                                        <el-input v-model="search" size="mini" autofocus :placeholder="$t('text.search_placeholder')"/>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button @click="beforeArchive(scope.row.id)" type="warning" size="mini"
                                            icon="mdi mdi-restore-clock">
                                            {{ $t('button.restore') }}
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Archive',
  data () {
    return {
      items: [],
      search: ''
    }
  },
  methods: {
    beforeArchive (id) {
      this.askQuestion(this.$t('item.confirm.restore'), () => {
        this.restore(this.items.indexOf(this.items.find(d => d.id === id)), id)
      })
    },
    async restore (index, id) {
      try {
        await this.withLoading(async () => {
          await this.$itemService.restoreItem(id)
          this.items.splice(index, 1)
          this.showSuccess(this.$t('item.message.restored'))
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in restoreItem:', error)
      }
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('item.title.archive'))
    try {
      await this.withLoading(async () => {
        this.items = await this.$itemService.getArchivedItems()
      }, 'loading')
    } catch (error) {
      // Error is already handled by the global interceptor
      console.log('Component caught error in getArchiveItems:', error)
    }
  }
}
</script>

<style scoped>

</style>
